import { useMutation } from '@tanstack/react-query';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { deleteDocuments } from '../requests';

export const useDeleteDocuments = () => {
  const { refetchAllDocumentsQueries } = useDocumentCache();

  return useMutation({
    mutationFn: deleteDocuments,
    onSuccess: refetchAllDocumentsQueries,
  });
};
